import { render, staticRenderFns } from "./PostGroupItems.vue?vue&type=template&id=d9c0ff78"
import script from "./PostGroupItems.vue?vue&type=script&lang=js"
export * from "./PostGroupItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports